import { Stack } from '@fluentui/react';
import { useTranslation } from 'react-i18next';

/**
 * Compact display for severity & impact data.
 */

export const ImpactSeverityDisplay = ({ impact, severity }) => {
  const [t] = useTranslation('search');

  if (!impact && !severity) return null;

  return (
    <Stack horizontal tokens={{ childrenGap: '1.5em' }}>
      {impact && (
        <dl style={{ marginTop: '0px', marginBottom: '0px' }}>
          <dt>{t('Impact', { ns: 'search', defaultValue: 'Impact' })}</dt>
          <dd>{impact}</dd>
        </dl>
      )}
      {severity && (
        <dl style={{ marginTop: '0px', marginBottom: '0px' }}>
          <dt>{t('Severity', { ns: 'search', defaultValue: 'Severity' })}</dt>
          <dd>{severity}</dd>
        </dl>
      )}
    </Stack>
  );
};
